import { render, staticRenderFns } from "./creditDatagramDetail.vue?vue&type=template&id=df3d4f06&scoped=true"
import script from "./creditDatagramDetail.vue?vue&type=script&lang=js"
export * from "./creditDatagramDetail.vue?vue&type=script&lang=js"
import style0 from "./creditDatagramDetail.vue?vue&type=style&index=0&id=df3d4f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3d4f06",
  null
  
)

export default component.exports